import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AIAssistantComponent } from './ai-assistant.component';
import { AIButtonComponent } from './components/ai-button/ai-button.component';
import { AIChatWindowComponent } from './components/ai-chat-window/ai-chat-window.component';
import { AIModalComponent } from './components/ai-modal/ai-modal.component';
import { AIAssistantService } from './services/ai-assistant.service';
import { StandardAppGuard } from './guards/standard-app.guard';

@NgModule({
  declarations: [
    AIAssistantComponent,
    AIButtonComponent,
    AIChatWindowComponent,
    AIModalComponent,
  ],
  imports: [CommonModule],
  exports: [AIAssistantComponent],
  providers: [AIAssistantService, StandardAppGuard],
})
export class AIAssistantModule {}
